<div class="stats-modal">
    <header class="stats-modal__header">
        <div>
            <h3 class="stats-modal__title">Cererile mele — Ajutoare</h3>
            <p class="stats-modal__subtitle">
                {{ data.totalCount }} {{ totalLabel }} în total
                <ng-container *ngIf="data.lastUpdated"> · actualizat {{ relativeUpdate }}</ng-container>
            </p>
        </div>
        <button type="button" class="stats-modal__close" (click)="onClose()" aria-label="Închide">×</button>
    </header>

    <div class="stats-modal__grid">
        <button
            *ngFor="let stat of data.stats; trackBy: trackByKey"
            type="button"
            class="stats-modal__item"
            [ngClass]="stat.count > 0 ? 'stats-modal__item--' + stat.color : 'stats-modal__item--empty'"
            [class.stats-modal__item--active]="data.activeKey === stat.key"
            [disabled]="stat.count === 0"
            (click)="onItemClick(stat)">
            <span class="stats-modal__item-label">{{ stat.label }}</span>
            <span class="stats-modal__item-count">{{ stat.count }}</span>
        </button>
    </div>
</div>
